import {createRouter, createWebHistory} from 'vue-router';
import SiteHome from '@/components/SiteComponents/SiteHome.vue';
import NotFound from '@/components/SiteComponents/Main/Components/NotFound.vue';
import api from '@/api';
import {buildUrlPath} from '@/utils';

const routes = [
    {
        path: '/',
        name: 'SiteHome',
        component: SiteHome,
    },
    {
        path: '/:type/:pathMatch(.*)*',
        name: 'DynamicRoute',
        component: SiteHome,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
    const navbarItemId = parseInt(localStorage.getItem('navbar_item')) || 1;
    const language = localStorage.getItem('language') || 'uz';

    let navbarItems = [];
    try {
        const {data} = await api.get('/nav-item/', {
            headers: {
                'Accept-Language': language,
            },
        });
        navbarItems = data;
    } catch (error) {
        console.error('Navbar ma\'lumotlari olinmadi:', error);
    }

    const expectedPath = buildUrlPath(navbarItems, navbarItemId);

    if (to.path !== expectedPath && to.name !== 'NotFound') {
        return next(expectedPath);
    }

    next();
});

export default router;
